import baustein from "baustein";
import browser from "web/script/utils/browser";
import style from "web/script/dom/style";
import { WIDE_MENU_BREAKPOINT } from "web/script/components/app-header-menu";

const BASE_CLASS = "mobile-feed-toolbar";
const FIXING_CLASS = `${BASE_CLASS}--fixed`;
const HAS_DESIGNERS_CLASS = `${BASE_CLASS}--has-designers`;
const WRAPPER_SELECTOR = `.${BASE_CLASS}__inner-wrapper`;

const APP_HEADER_BAR_HEIGHT = 116;
export const APP_HEADER_BAR_DESKTOP_HEIGHT = 69;
export const APP_PRE_HEADER_BAR_HEIGHT = 40;

/**
 * @constructor
 * @alias module:components/mobile-feed-toolbar
 * @extends module:components/components
 */
export default baustein.register("mobile-feed-toolbar", {
    /** @lends module:components/mobile-feed-toolbar.prototype */

    /*
     * Is it already fixed.
     */
    isFixed: false,

    /*
     * Determines if mobile-feed-toolbar should be fixed / unfixed on page loads depending
     * on scroll position
     *
     * Also sets mobile-feed-toolbar top position if it's fixed
     */
    init() {},

    setupEvents(add) {
        add("onQuickFiltersGetData", this._handleQuickFiltersGetData);
    },

    onInsert() {
        const quickFilterCards = this.findComponent("quick-filters-card");
        if (quickFilterCards) {
            const quickFiltersHasDesigners = quickFilterCards.el.classList.contains(
                "quick-filters-card--has-designers"
            );
            this._toggleHasDesignersClass(quickFiltersHasDesigners);
        }
    },

    onRemove() {
        this.releaseAllGlobalHandlers();
    },

    _toggleHasDesignersClass(hasDesigners) {
        if (hasDesigners) {
            this.el.classList.add(HAS_DESIGNERS_CLASS);
        } else {
            this.el.classList.remove(HAS_DESIGNERS_CLASS);
        }
    },

    _handleQuickFiltersGetData(data) {
        this._toggleHasDesignersClass(data.has_designers);
    },

    /*
     * Scroll handler, fixes & unfixes toolbar
     */
    _onScroll() {
        const headerHeight = this._computeHeaderHeight();
        const fixUnfixThreshold = this.isFixed
            ? headerHeight + APP_PRE_HEADER_BAR_HEIGHT
            : headerHeight;
        const shouldBeFixed = style.getPosition(this.el).top <= fixUnfixThreshold;

        // toggles on fixed / non-fixed threshold
        if (shouldBeFixed !== this.isFixed) {
            this.el.classList.toggle(FIXING_CLASS);
            this.isFixed = !this.isFixed;

            const wrapperElement = this.el.querySelector(WRAPPER_SELECTOR);
            if (this.isFixed) {
                wrapperElement.style.top = `${headerHeight}px`;
            } else {
                wrapperElement.style.top = null;
            }

            const quickFilterCards = this.findComponent("quick-filters-card");
            if (quickFilterCards) {
                quickFilterCards.onToolbarPin();
            }
        }
    },

    /*
     * Listens to appHeaderUpdatedOffset event and
     * recalculates toolbar top position based on pre header varying height
     */
    updatePosition(appHeaderOffset) {
        // only recalculate toolbar top position when the bar is fixed,
        // this is the only time when it will varies
        if (this.el.classList.contains(FIXING_CLASS)) {
            const wrapperElement = this.el.querySelector(WRAPPER_SELECTOR);
            // The offset of mobile feed toolbar from top of windows is calculated by
            // deducting the app header translating from the app header + pre header height
            const offset =
                this._computeHeaderHeight() + APP_PRE_HEADER_BAR_HEIGHT - appHeaderOffset;
            wrapperElement.style.top = `${offset}px`;
        }
    },

    /**
     * Returns the static height for the current Header element.
     * @returns {number}
     */
    _computeHeaderHeight() {
        return browser.getWindowWidth() < WIDE_MENU_BREAKPOINT
            ? APP_HEADER_BAR_HEIGHT
            : APP_HEADER_BAR_DESKTOP_HEIGHT;
    },
});
